import { z } from "zod";
export const auditResultEnum = z.enum(["SUCCESS", "FAILURE", "PARTIAL"]);
export const auditEntrySchema = z.object({
    id: z.number(),
    at: z.string(),
    actorUserId: z.number().nullable(),
    actorEmail: z.string().nullable(),
    actorIp: z.string().nullable(),
    action: z.string(),
    resourceType: z.string(),
    resourceId: z.string().nullable(),
    targetIdcompany: z.number().nullable(),
    result: auditResultEnum,
    reason: z.string().nullable(),
    requestId: z.string().nullable(),
});
export const auditFiltersSchema = z.object({
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    actorEmail: z.string().optional(),
    action: z.string().optional(),
    resourceType: z.string().optional(),
    /** Con resourceType: el recurso puntual (por ejemplo, el IDCANAL de un webchat). */
    resourceId: z.string().trim().min(1).max(100).optional(),
    idcompany: z.coerce.number().int().positive().optional(),
    result: auditResultEnum.optional(),
});
//# sourceMappingURL=audit.js.map